/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Signer } from "ethers";
import { Provider, TransactionRequest } from "@ethersproject/providers";
import { Contract, ContractFactory, Overrides } from "@ethersproject/contracts";

import type { DIARandomOracle } from "../DIARandomOracle";

export class DIARandomOracle__factory extends ContractFactory {
  constructor(signer?: Signer) {
    super(_abi, _bytecode, signer);
  }

  deploy(overrides?: Overrides): Promise<DIARandomOracle> {
    return super.deploy(overrides || {}) as Promise<DIARandomOracle>;
  }
  getDeployTransaction(overrides?: Overrides): TransactionRequest {
    return super.getDeployTransaction(overrides || {});
  }
  attach(address: string): DIARandomOracle {
    return super.attach(address) as DIARandomOracle;
  }
  connect(signer: Signer): DIARandomOracle__factory {
    return super.connect(signer) as DIARandomOracle__factory;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): DIARandomOracle {
    return new Contract(address, _abi, signerOrProvider) as DIARandomOracle;
  }
}

const _abi = [
  {
    inputs: [],
    stateMutability: "nonpayable",
    type: "constructor",
  },
  {
    inputs: [],
    name: "getLastRound",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_round",
        type: "uint256",
      },
    ],
    name: "getRandomValueFromRound",
    outputs: [
      {
        internalType: "string",
        name: "",
        type: "string",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "round",
        type: "uint256",
      },
    ],
    name: "increaseRound",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function",
  },
  {
    inputs: [],
    name: "lastRound",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256",
      },
    ],
    stateMutability: "view",
    type: "function",
  },
];

const _bytecode =
  "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";
